import SalviaLayout from "@/components/SalviaLayout";
import { useAuth } from "@/_core/hooks/useAuth";
import { trpc } from "@/lib/trpc";
import { usePageTitle } from "@/hooks/usePageTitle";
import { KPICard, KPICardRow, PipelineChart, QualifierChart, CampaignSummaryChart } from "@/components/dashboard";
import { Card } from "@/components/ui/card";
import { AlertTriangle, Building2, Users, FileText, Activity, Layers, UserCheck } from "lucide-react";

export default function SalviaEcossistema() {
  usePageTitle("Ecossistema");
  const { user } = useAuth();
  const { data, isLoading, error } = trpc.dashboards.salvia.ecosystem.useQuery(undefined, {
    enabled: !!user && user.role === "admin",
    refetchOnWindowFocus: false,
  });

  if (error) {
    return (
      <SalviaLayout title="Dashboard — Ecossistema">
        <Card className="p-8 text-center">
          <AlertTriangle className="mx-auto mb-4 text-destructive" size={48} />
          <h2 className="text-lg font-semibold mb-2">Erro ao carregar dashboard</h2>
          <p className="text-muted-foreground">{error.message}</p>
        </Card>
      </SalviaLayout>
    );
  }

  const loading = isLoading || !data;

  return (
    <SalviaLayout title="Dashboard — Ecossistema">
      <div className="space-y-6">
        {/* KPI Cards */}
        <KPICardRow>
          <KPICard
            label="Canais Ativos"
            value={data?.cards.totalChannels ?? 0}
            icon={Layers}
            iconColor="text-violet-600"
            iconBg="bg-violet-100"
            loading={loading}
          />
          <KPICard
            label="Clientes"
            value={data?.cards.totalCompanies ?? 0}
            icon={Building2}
            iconColor="text-blue-600"
            iconBg="bg-blue-100"
            loading={loading}
          />
          <KPICard
            label="Usuários Ativos"
            value={data?.cards.totalUsers ?? 0}
            icon={UserCheck}
            iconColor="text-emerald-600"
            iconBg="bg-emerald-100"
            loading={loading}
          />
          <KPICard
            label="Documentos Gerados"
            value={data?.cards.docsReady ?? 0}
            icon={FileText}
            iconColor="text-green-600"
            iconBg="bg-green-100"
            subtitle={data?.cards.docsFailed ? `${data.cards.docsFailed} com falha` : undefined}
            loading={loading}
          />
        </KPICardRow>

        {/* Charts Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <PipelineChart
            pipeline={data?.pipeline ?? {}}
            title="Pipeline de Avaliações"
            loading={loading}
          />
          <QualifierChart
            data={data?.qualifierDistribution ?? []}
            title="Qualificadores"
            loading={loading}
          />
        </div>

        {/* Second Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <QualifierChart
            data={data?.classificationDistribution ?? []}
            title="Classificação de Risco (P×S)"
            loading={loading}
          />
          <CampaignSummaryChart
            campaigns={data?.campaigns ?? {}}
            title="Campanhas do Ecossistema"
            loading={loading}
          />
        </div>
      </div>
    </SalviaLayout>
  );
}
